import { render, staticRenderFns } from "./ConsumableLog.vue?vue&type=template&id=bfefc2f2&scoped=true"
import script from "./ConsumableLog.vue?vue&type=script&lang=js"
export * from "./ConsumableLog.vue?vue&type=script&lang=js"
import style0 from "./ConsumableLog.vue?vue&type=style&index=0&id=bfefc2f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfefc2f2",
  null
  
)

export default component.exports